import React, { useState, useEffect, useCallback } from 'react';
import socketService from '../services/socketService';
import Layout from '../components/Layout';
import moment from 'moment';

const ApiLogViewer = () => {
    // State Management
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRows, setTotalRows] = useState(0);

    // 1. Data Fetching Function
// 1. Data Fetching Function
// 1. Data Fetching Function
const fetchLogs = useCallback(() => {
    setLoading(true);
    
    // LocalStorage থেকে ডাটা নিচ্ছি
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}; 
    const allowedUsers = JSON.parse(localStorage.getItem('allowedUsers')) || [];
    
    // 🔥 আপনার আইডিয়া অনুযায়ী localStorage থেকে isMaster চেক করছি
    const isMaster = localStorage.getItem('isMaster'); 

    socketService.emit('fetch_api_logs', {
        page: currentPage,
        search: searchTerm,
        isMaster: isMaster, // এটি 'true' বা 'false' হিসেবে ব্যাকএন্ডে যাবে
        allowedUsers: allowedUsers, 
        currentUsername: userInfo.username 
    });
}, [currentPage, searchTerm]);

    // 2. Socket Listeners
    useEffect(() => {
        socketService.connect();

        const handleDataReceive = (data) => {
            setLogs(data.logs || []);
            setTotalPages(data.totalPages || 1);
            setTotalRows(data.totalRows || 0);
            setLoading(false);
        };

        socketService.on('receive_api_logs', handleDataReceive);
        
        // Initial Fetch
        fetchLogs();

        return () => {
            socketService.off('receive_api_logs', handleDataReceive);
        };
    }, [fetchLogs]);

    // 3. Handlers
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        const maxVisibleButtons = 15; 
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                    <button className="page-link shadow-none" onClick={() => handlePageChange(i)}>{i}</button>
                </li>
            );
        }
        return pages;
    };

    // 🔥 Postman Style Syntax Highlighting Logic
    const syntaxHighlight = (json) => {
        if (typeof json !== 'string') {
            json = JSON.stringify(json, undefined, 2);
        }
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            let cls = 'number';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key'; 
                } else {
                    cls = 'string'; 
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }
            return '<span class="' + cls + '">' + match + '</span>';
        });
    };

    // 🔥 Custom Code Block Component
    const CodeView = ({ data }) => {
        let content = data;
        let isJson = false;

        try {
            const parsed = typeof data === 'string' ? JSON.parse(data) : data;
            content = syntaxHighlight(parsed); 
            isJson = true;
        } catch (e) {
            content = data;
        }

        return (
            <div className="postman-viewer">
                {isJson ? (
                    <pre dangerouslySetInnerHTML={{ __html: content }} />
                ) : (
                    <pre style={{color: '#d4d4d4'}}>{content}</pre>
                )}
            </div>
        );
    };

    return (
        <Layout>
            <div className="main-content-area py-3 px-10">
                {/* Header Section */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="section-title m-0">📡 API Traffic Monitor</h5>
                    <div className="d-flex gap-2">
                        <div className="count-badge shadow-sm">
                            Total Logs: <span>{totalRows}</span>
                        </div>
                    </div>
                </div>

                {/* Filter Section */}
                <div className="filter-card shadow-sm border-0 mb-4">
                    <div className="row g-2 align-items-end">
                        <div className="col-md-5">
                            <label className="field-label">SEARCH BY TrxID / NUMBER / KEY / USER</label>
                            <input 
                                type="text" 
                                className="modern-input" 
                                placeholder="Type TrxID, Phone Number, Key or User..." 
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="col-md-2">
                            <button className="btn btn-apply fw-bold w-100" onClick={fetchLogs}>
                                Search Data
                            </button>
                        </div>
                    </div>
                </div>

                {/* Table Section */}
                <div className="table-container shadow-sm border-0 mb-3">
                    <div className="table-responsive">
                        <table className="custom-zebra-table">
                            <thead>
                                <tr>
                                    <th className="ps-4" style={{width: '15%'}}>USER INFO</th>
                                    <th style={{width: '35%'}}>REQUEST BODY</th>
                                    <th style={{width: '35%'}}>RESPONSE BODY</th>
                                    <th className="text-end pe-4" style={{width: '15%'}}>TIMESTAMP</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan="4" className="text-center py-5">Loading Logs...</td></tr>
                                ) : logs.length === 0 ? (
                                    <tr><td colSpan="4" className="text-center py-5 opacity-50">No Data Found</td></tr>
                                ) : (
                                    logs.map((log) => {
                                        // 🔥 FAILED CHECK LOGIC
                                        let isFailed = false;
                                        try {
                                            const resObj = JSON.parse(log.responseData);
                                            // যদি status failed হয়
                                            if (resObj && resObj.status === 'failed') {
                                                isFailed = true;
                                            }
                                        } catch (e) {
                                            // JSON পার্স না হলে স্কিপ করবে
                                        }

                                        // 🔥 রো এর স্টাইল: ফেইল হলে হালকা লাল, নাহলে সাধারণ
                                        const rowStyle = {
                                            verticalAlign: 'top',
                                            backgroundColor: isFailed ? '#fff1f2' : 'inherit', // Light Red for failed
                                            borderLeft: isFailed ? '4px solid #f43f5e' : 'none' // বামে একটা লাল বর্ডার
                                        };

                                        return (
                                            <tr key={log._id} style={rowStyle}>
                                                <td className="ps-4 pt-3">
                                                    <div className="user-primary">{log.username}</div>
                                                    <div className="device-secondary text-uppercase mt-1" style={{fontSize: '10px', letterSpacing: '0.5px', background: isFailed ? '#fee2e2' : '#e2e8f0', padding: '2px 6px', borderRadius: '4px'}}>
                                                        KEY: <span style={{fontFamily: 'monospace'}}>{log.apiKey ? log.apiKey.substring(0, 8) : 'N/A'}...</span>
                                                    </div>
                                                    <div className="mt-2 text-muted" style={{fontSize: '10px'}}>
                                                        ID: #{log._id.slice(-6).toUpperCase()}
                                                    </div>
                                                    {isFailed && (
                                                        <div className="mt-2 badge bg-danger text-white" style={{fontSize: '10px'}}>FAILED</div>
                                                    )}
                                                </td>

                                                <td className="pt-3 pb-3">
                                                    <div className="code-label mb-1">PAYLOAD</div>
                                                    <CodeView data={log.requestData} />
                                                </td>

                                                <td className="pt-3 pb-3">
                                                    <div className="code-label mb-1">RESPONSE</div>
                                                    <CodeView data={log.responseData} />
                                                </td>

                                                <td className="text-end pe-4 pt-3">
                                                    <div className="date-bold" style={{color: '#334155'}}>
                                                        {moment(log.created_at).format('DD MMM YYYY')}
                                                    </div>
                                                    <div className="time-muted" style={{fontSize: '11px'}}>
                                                        {moment(log.created_at).format('hh:mm:ss A')}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center px-2 py-2">
                    <div className="text-muted small">
                        Showing Page <b>{currentPage}</b> of <b>{totalPages}</b>
                    </div>
                    <nav>
                        <ul className="pagination pagination-sm m-0 gap-1">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link shadow-none" onClick={() => handlePageChange(currentPage - 1)}>Prev</button>
                            </li>
                            {renderPageNumbers()}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link shadow-none" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            {/* 🔥 POSTMAN STYLE CSS */}
            <style>{`
                .main-content-area { background-color: #f4f7fa; min-height: 100vh; font-family: 'Inter', sans-serif; }
                .section-title { color: #334155; font-weight: 700; }
                .count-badge { background: #fff; padding: 5px 15px; border-radius: 50px; border: 1px solid #e2e8f0; font-size: 13px; }
                .count-badge span { color: #0284c7; font-weight: 800; }
                
                .filter-card { background: #ffffff; padding: 15px; border-radius: 12px; }
                .field-label { font-size: 10px; font-weight: 700; color: #64748b; margin-bottom: 5px; text-transform: uppercase; }
                .modern-input { background: #f8fafc; border: 1px solid #cbd5e1; padding: 7px 10px; border-radius: 8px; font-size: 12px; width: 100%; outline: none; }
                
                .btn-apply { background: #0284c7; color: white; border-radius: 8px; font-size: 12px; transition: 0.3s; border: none; padding: 8px 0; }
                .btn-apply:hover { background: #0369a1; transform: translateY(-1px); }
                
                .table-container { background: #ffffff; border-radius: 12px; overflow: hidden; }
                .custom-zebra-table { width: 100%; border-collapse: collapse; }
                .custom-zebra-table thead { background: #f1f5f9; color: #475569; border-bottom: 2px solid #e2e8f0; }
                .custom-zebra-table th { padding: 14px 15px; font-size: 11px; font-weight: 800; text-transform: uppercase; text-align: left; }
                
                /* Zebra Stripe Logic Modified to support colored rows */
                .custom-zebra-table tbody tr:nth-child(even) { 
                    /* We set background explicitly in inline style now for logic */
                }
                .custom-zebra-table td { border-bottom: 1px solid #edf2f7; }
                
                .user-primary { color: #0369a1; font-weight: 700; font-size: 14px; }
                .code-label { font-size: 10px; font-weight: 700; color: #94a3b8; letter-spacing: 0.5px; }

                .page-link { color: #475569; border: 1px solid #e2e8f0; border-radius: 6px !important; padding: 5px 12px; font-weight: 600; background: white; }
                .page-item.active .page-link { background-color: #0284c7; border-color: #0284c7; color: white; }

                /* 🔥 POSTMAN CODE VIEWER STYLES */
                .postman-viewer {
                    background-color: #212121; /* Postman Dark BG */
                    color: #d4d4d4;
                    padding: 12px;
                    border-radius: 6px;
                    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
                    font-size: 12px;
                    line-height: 1.5;
                    overflow: auto;
                    max-width: 480px;
                    border: 1px solid #333;
                    max-height: 300px; /* Scroll if too long */
                }

                .postman-viewer pre { margin: 0; white-space: pre-wrap; word-break: break-all; }

                /* Syntax Highlighting Colors */
                .string { color: #ce9178; }  /* Orange/Salmon for strings */
                .number { color: #b5cea8; }  /* Light Green for numbers */
                .boolean { color: #569cd6; } /* Blue for booleans */
                .null { color: #569cd6; }    /* Blue for null */
                .key { color: #9cdcfe; }     /* Light Blue for keys */

                /* Custom Scrollbar */
                .postman-viewer::-webkit-scrollbar { width: 8px; height: 8px; }
                .postman-viewer::-webkit-scrollbar-track { background: #1e1e1e; }
                .postman-viewer::-webkit-scrollbar-thumb { background: #424242; border-radius: 4px; }
                .postman-viewer::-webkit-scrollbar-thumb:hover { background: #4f4f4f; }
            `}</style>
        </Layout>
    );
};

export default ApiLogViewer;